<template>
  <div style="display:inline-block;">
    <a
      v-show="show"
      class="js-code-bbtn btn"
      data-url="ddd"
      href="javascript:;"
      :disabled="isDisabled"
      @click="sendCode"
    >
      {{ $t('message["460"]') }}
    </a>
    <em
      v-show="!show"
      class="btn counter send-time"
    >{{ counter }}s</em>
  </div>
</template>

<script>
// mport { fetchApi } from '@/common'
import { validCode } from '@/services'
export default {
  props: {
    type: {
      type: String,
      default: '1'
    },
    mobile: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    },
    newmobile: {
      type: String,
      default: ''
    },
    newemail: {
      type: String,
      default: ''
    },
    username: {
      type: String,
      default: ''
    },
    // 按钮是否禁止
    isDisabled: {
      type: Boolean,
      default: true
    },
    imgcaptcha: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      timer: null,
      counter: 60,
      show: true
    }
  },
  computed: {
    fileds () {
      const type = parseInt(this.type)
      if (type === 1 || type === 3 || type === 7) {
        return {
          type,
          mobile: this.mobile,
          imgcaptcha: this.imgcaptcha
        }
      } else if (type === 2 || type === 4 || type === 8) {
        return {
          type,
          email: this.email
        }
      } else if (type === 5) {
        return {
          type,
          newmobile: this.newmobile,
          mobile: this.mobile
        }
      } else if (type === 6) {
        return {
          type,
          newemail: this.newemail
        }
      } else if (type === 9) {
        return {
          type,
          mobile: this.mobile,
          imgcaptcha: this.imgcaptcha
        }
      } else if (type === 10) {
        return {
          type,
          mobile: this.mobile,
          imgcaptcha: this.imgcaptcha
        }
      } else if (type === 11) {
        return {
          type,
          mobile: this.mobile,
          imgcaptcha: this.imgcaptcha
        }
      } else if (type === 12) {
        return {
          type,
          mobile: this.mobile,
          imgcaptcha: this.imgcaptcha
        }
      } else if (type === 13) {
        return {
          type,
          mobile: this.mobile,
          imgcaptcha: this.imgcaptcha
        }
      } else if (type === 14) {
        return {
          type,
          mobile: this.mobile,
          imgcaptcha: this.imgcaptcha
        }
      } else {
        return {
          type,
          mobile: this.mobile
        }
      }
    }
  },
  methods: {
    async sendCode () {
      await validCode()
        .params(this.fileds)
        .onSuccess((raw, res) => {
          if (!res.error) {
            this.showCount()
            this.$emit('getRes', res.payload)
          }
        })
        .onNetSuccess((res) => {
          // console.log(res.data.message)
          // const toast = this.$createToast({
          //   time: 2000,
          //   txt: res.data.message,
          //   type: 'txt'
          // })
          // toast.show()
          const error = res.data.error
          if (!error) {
            this.$selefToast({ text: res.data.message })
          } else {
            this.$selefToast({ type: 'error', text: res.data.message })
          }
        })
        .config({ tip: false })
        .fetch()
    },
    showCount () {
      const that = this
      that.show = false
      const defaultCount = that.counter
      const interval = setInterval((params) => {
        if (that.counter <= 1) {
          that.show = true
          that.counter = defaultCount
          clearInterval(interval)
        } else {
          that.counter--
        }
      }, 1000)
    }
  }
}
</script>
<style lang="scss" scoped>
  .send-time {
    color: #b3b3b3;
  }
</style>
